import {HttpClient} from '@angular/common/http';
import {Inject, Injectable, LOCALE_ID} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {environment} from '~environments/environment';
import {Country} from '../models';

/**
 * Service responsible for getting countries.
 */
@Injectable()
export class CountryService {
  public API_URL: string = environment.envAPI;
  public countries: Array<Country>;

  constructor(private http: HttpClient, @Inject(LOCALE_ID) public locale: any) {
  }

  /**
   * Get all countries. Even the Ascension Islands.
   */
  public getCountries(): Observable<Array<Country>> {
    const url = `${this.API_URL}/countries?locale=${this.locale}`;
    return this.http.get(url).pipe(
      map((response: any) => {
        const countries: Array<Country> = [];
        for (const key of Object.keys(response)) {
          countries.push(new Country(key, response[key]));
        }
        return countries;
      })
    );
  }

  /**
   * Get country by the locale.
   */
  public getCountry(key: any, countries: any): any {
    if (countries) {
      const country = countries.find(el => el['iso2'] === key);
      return country ? country['name'] : null;
    }
  }
}
